import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { Philosophy } from '../components/Philosophy';
import { Offerings } from '../components/Offerings';
import { Retreats } from '../components/Retreats';
import { Testimonials } from '../components/Testimonials';
import { Schedule } from '../components/Schedule';
import { Connect } from '../components/Connect';
type HomeLocationState = {
  scrollTo?: string;
} | null;
export function Home() {
  const location = useLocation();
  useEffect(() => {
    const state = location.state as HomeLocationState;
    if (!state?.scrollTo) return;
    const target = document.getElementById(state.scrollTo);
    if (target) {
      window.requestAnimationFrame(() => target.scrollIntoView({
        behavior: 'smooth'
      }));
    }
  }, [location]);
  return <main data-id="element-303" data-mp="3kuqyxj5m2bnu">
      <Hero data-id="element-304" data-mp="3kxd2z8tam91b" />
      <Philosophy data-id="element-305" data-mp="3kxmrst2lqa5f" />
      <Offerings data-id="element-306" data-mp="3owlwqdoc26wv" />
      <Retreats data-id="element-307" data-mp="3ow42fml8e2rl" />
      <Testimonials data-id="element-308" data-mp="3ovkhdx0aay9c" />
      <Schedule data-id="element-309" data-mp="3ov2i0ribs3x7" />
      <Connect data-id="element-310" data-mp="3oyq6hc8wy052" />
    </main>;
}